import { Component, Injectable, Input, NgZone, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TypeaheadBaseComponent } from '@bhtp-client-web/component';
import { AgentNameTypeaheadService } from '../../services';
import { ApiAgentInformation } from '../../models';

const AGENT_TYPEAHEAD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TypeaheadAgentNameSearchComponent),
    multi: true
};

@Component({
    selector: 'typeahead-agent-name-search',
    providers: [AGENT_TYPEAHEAD_VALUE_ACCESSOR],
    template: require('./typeahead-agent-search.component.html')
})
@Injectable()
export class TypeaheadAgentNameSearchComponent extends TypeaheadBaseComponent<ApiAgentInformation> {
    @Input() searchType: string;

    public itemDisplayPropertyName: string = 'agentName';
    public typeAheadWaitInMs: number = 175;
    public placeHolder: string = 'Agent Name';

    constructor(public typeaheadService: AgentNameTypeaheadService, zone: NgZone) {
        super(typeaheadService, zone);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/agents/typeahead-agent-name-search.component.ts